import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import CatalogPage from "@/pages/catalog/page";
import FeaturedCreatorsPage from "@/pages/featured/page";
import CategoriesPage from "@/pages/categories/page";
import ForumsPage from "@/pages/forums/page";
import SubmitPage from "@/pages/submit/page";
import AdminPage from "@/pages/admin/page";
import GroupsPage from "@/pages/groups/page";
import GroupSubmitPage from "@/pages/groups/submit";
import ConfessionsPage from "@/pages/confessions/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/catalog",
    element: <CatalogPage />,
  },
  {
    path: "/featured",
    element: <FeaturedCreatorsPage />,
  },
  {
    path: "/categories",
    element: <CategoriesPage />,
  },
  {
    path: "/forums",
    element: <ForumsPage />,
  },
  {
    path: "/submit",
    element: <SubmitPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/groups",
    element: <GroupsPage />,
  },
  {
    path: "/groups/submit",
    element: <GroupSubmitPage />,
  },
  {
    path: "/confessions",
    element: <ConfessionsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
